import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Icon, Toast, Tag } from 'antd-mobile';
import tips from 'tips';
import './index.less';
import Btn from 'Btn';

let popPwdQueue = [];

class RateComponent extends Component {
  state = {
    rate: '',
    textShow: false,
    tList: {
      dissatisArr: [
        '退款速度慢',
        '价格不透明',
        '系统体验差',
        '操作卡顿',
        '其他',
      ],
      satisArr: ['退款速度快', '价格透明', '系统体验好', '操作便捷', '其他'],
    },
    sList: {
      satisArr: ['价格透明', '支付安全便捷', '系统体验佳', '其他'],
      dissatisArr: ['价格不透明', '支付不够便捷', '系统体验差', '其他'],
    },
    describe: '',
  };
  reasonOptions = [];
  static props = {
    title: PropTypes.string,
    destroy: PropTypes.func,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
  };

  static defaultProps = {
    destroy: () => {},
    getList: () => {},
    onConfirm: destroy => {
      // toHome && toHome();
      destroy && destroy();
    },
    onCancel: (destroy, toHome) => {
      toHome && toHome();
      destroy && destroy();
    },
  };

  setRate = val => {
    const { rate } = this.state;
    if ((rate > 8 && val < 8) || (rate < 7 && val > 7)) {
      this.setState({
        textShow: false,
      });
    }

    this.setState({
      rate: val,
    });
  };

  rateReason = (selected, item) => {
    if (selected && item === '其他') {
      this.setState({
        textShow: true,
      });
    } else if (!selected && item === '其他') {
      this.setState({
        textShow: false,
      });
    }

    if (selected && item !== '其他') {
      this.reasonOptions.push(item);
    } else {
      this.reasonOptions = this.reasonOptions.filter(i => i !== item);
    }
  };

  textInput = e => {
    this.setState({
      describe: e.target.value,
    });
  };

  renderRateTab = orderNo => {
    const { rate, textShow, sList, tList } = this.state;
    let arr;
    if (orderNo.indexOf('S') !== -1) {
      arr = sList;
    } else {
      arr = tList;
    }
    return (
      <div>
        {typeof rate === 'number' && rate <= 6 && (
          <div className="reasonItem">
            <div className="text">在使用时遇到了问题?</div>
            <div>
              {arr.dissatisArr.map((item, index) => {
                return (
                  <Tag
                    onChange={selected => {
                      this.rateReason(selected, item);
                    }}
                  >
                    {item}
                  </Tag>
                );
              })}
            </div>
            {textShow && (
              <textarea
                placeholder="请描述您的问题"
                rows="3"
                onChange={e => {
                  this.textInput(e);
                }}
              />
            )}
          </div>
        )}
        {rate > 8 && (
          <div className="reasonItem">
            <div className="text">推荐的原因是?</div>
            <div>
              {arr.satisArr.map((item, index) => {
                return (
                  <Tag
                    onChange={selected => {
                      this.rateReason(selected, item);
                    }}
                  >
                    {item}
                  </Tag>
                );
              })}
            </div>
            {textShow && (
              <textarea
                placeholder="请描述您的问题"
                rows="3"
                onChange={e => {
                  this.textInput(e);
                }}
              />
            )}
          </div>
        )}
      </div>
    );
  };

  render() {
    const { onCancel, onConfirm, destroy, toHome, orderNo } = this.props;
    const { rate, describe } = this.state;

    return (
      <section className="pop-pwd rate_pop">
        <div
          className="pop-pwd-content"
          role="dialog"
          tabIndex="-1"
          aria-modal="true"
        >
          <p className="rateTitle">
            您是否愿意向您的亲戚朋友推荐在线
            {orderNo.indexOf('S') === -1 ? `退票` : `变更`}?
          </p>
          <Icon
            type="cross"
            onClick={e => onCancel(destroy, toHome)}
            role="button"
            aria-label="关闭"
          />
          <div className="rateList">
            {new Array(11).fill('').map((item, index) => {
              return (
                <i
                  className={`rateNum ${rate === index && 'checkedNum'}`}
                  onClick={() => this.setRate(index)}
                >
                  {index}
                </i>
              );
            })}
          </div>
          <div className="view">
            <span>非常不愿意</span>
            <span>非常愿意</span>
          </div>
          <div>
            <div>{this.renderRateTab(orderNo)}</div>
          </div>
          <div className="rateBtn">
            <Btn
              text="提交"
              onClick={e => onConfirm(rate, describe, this.reasonOptions)}
            />
            <Btn text="跳过" onClick={e => onCancel(destroy, toHome)} />
          </div>
        </div>
      </section>
    );
  }
}

function renderNode(props) {
  let div = document.createElement('div');
  document.body.appendChild(div);

  const destroy = () => {
    if (!div) return;
    ReactDOM.unmountComponentAtNode(div);
    document.body.removeChild(div);
    div = null;
  };

  const onConfirm = async (psg, describe, reasonOptions) => {
    if (!psg && psg !== 0) {
      Toast.info(tips.rateTip.rateTip, 1);
      return;
    }

    let list = {
      type: props.orderNum.indexOf('S') !== -1 ? '4' : '3',
      oddNumbers: props.orderNum,
      score: psg,
      describe: describe,
      reasonOptions: reasonOptions.toString(),
    };

    const {
      payload: { data },
    } = await props.crateNps(list);
    if (data.status === 0) {
      Toast.info(tips.rateTip.rateSuccess, 2);
      props.toHome ? props.toHome() : destroy();
      destroy();
    } else {
      destroy();
    }
  };

  ReactDOM.render(
    <RateComponent
      {...props}
      destroy={destroy}
      onConfirm={onConfirm}
      toHome={props.toHome}
      orderNo={props.orderNum}
    />,
    div
  );

  popPwdQueue.push(destroy);
  return popPwdQueue[popPwdQueue.length - 1];
}

export default function ratePopup(query, crateNps, toHome) {
  renderNode({
    orderNum: query.orderNo,
    crateNps: crateNps,
    toHome: toHome,
  });
}

// PopPwd.clear = () => {
//   if (popPwdQueue && popPwdQueue.length) {
//     popPwdQueue.forEach(progess => {
//       progess();
//     });
//     popPwdQueue = [];
//   }
// };



// WEBPACK FOOTER //
// ./src/components/RatePopup/index.js